<template>
    <button class="btn btn-outline-danger btn-sm btn-block waves-effect waves-light bg-sky-500 hover:bg-sky-800" @click="logout()">Выход</button>
    <!-- <textarea style="width: 100%; height: 150px;">{{ user }}</textarea> -->
    <!-- <textarea style="width: 100%; height: 150px;">{{ this.$store.state.user }}</textarea> -->
</template>

<script>
// import sessionCheck from '@/VueWorking/sessionCheck.js';
import useAuth from '@/VueWorking/useAuth.js';
export default {
    name: 'Login',
    data(){
        return {
            // user: {}
        }
    },
    mounted() {
        // this.user = this.getUser();
        // this.user = this.$store.getters.getUser;
    },
    methods: {
        async logout(){
            await useAuth().logout();
            this.$router.push({ path: "/login" });
            // let _this = this;
            // axios.get('/sanctum/csrf-cookie').then(response => {
            //     console.log(response);
            //     axios.post('/logout', 
            //         _this.formData, 
            //         { headers: { 'Content-Type': 'application/json' }}
            //     )
            //     .then(function(res){
            //         console.log(res.data);
            //         _this.result = res.data;
            //         // _this.$store.dispatch('logout');
            //         // _this.$router.push({ path: "/login" });
            //         // sessionCheck().logoutSession();
            //         useAuth().logout();
            //     })
            //     .catch(function(error){
            //         console.log(error);
            //         window.$func.exceptionsHandler(error);
            //     });
            // });
        },
    }
}
</script>